import { Component, OnInit, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ViewTableComponent } from '../../base/view-table/view-table.component';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'src/app/services/utility.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { FormBuilder } from '@angular/forms';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Renderer2 } from '@angular/core';
import { PrintService } from 'src/app/services/print.service';
import { RefreshService } from 'src/app/services/refresh.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { TranslateService } from '@ngx-translate/core';
import { WeekYearChangeEvent } from '../../shared/week-year-selector/week-year-selector.component';
import { CurrencyService } from '../../../services/currency.service';

@Component({
  selector: 'app-value-lesson-taught-report',
  templateUrl: './value-lesson-taught-report.component.html',
  styleUrls: ['./value-lesson-taught-report.component.css']
})
export class ValueLessonTaughtReportComponent extends ViewTableComponent implements OnInit {

  year: string;
  week: string;
  override WeeksForYearData: any[] = [];
  override LastFourYearsData: any[] = this.getLastFourYears();
  dateTimeRange: Date[] = [];
  isDateRangeActive: boolean = false;

  // Report specific properties
  showOptions: string[] = ['Units Used', 'Number of Lessons', 'Total Lessons Time'];
  selectedShow: string = 'Units Used';

  groupByOptions: string[] = ['Instructor', 'Level', 'Student', 'Day of the Week', 'Day', 'Week', 'Month'];
  selectedGroupBy: string = 'Instructor';

  student: string = '';
  instructor: string = '';

  // Data properties
  reportData: any[] = [];
  summary: any = null;

  constructor(
    public override _refreshService: RefreshService,
    private _printService: PrintService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService,
    private currencyService: CurrencyService,
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  getCurrentWeek() {
    return this._fieldsService.getCurrentWeek().toString();
  }

  override ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      const now = new Date();
      const currentYear = this._fieldsService.getCorrectYearForWeek(now);
      if (params['date_from'] && params['date_to']) {
        const startDate = this.reportDateService.parseCalendarDateInput(params['date_from']);
        const endDate = this.reportDateService.parseCalendarDateInput(params['date_to']);
        if (startDate && endDate) {
          this.dateTimeRange = [startDate, endDate];
          this.isDateRangeActive = true;
        } else {
          this.dateTimeRange = [];
          this.isDateRangeActive = false;
        }
        this.year = currentYear.toString();
        this.week = this.getCurrentWeek();
        this.onYearChange(this.year);
      } else {
        this.isDateRangeActive = false;
        this.year = params['year'] || currentYear.toString();
        this.week = params['week'] || this.getCurrentWeek();
        this.onYearChange(this.year);
      }

      // Set filter values from query params if available
      this.selectedShow = params['show'] || this.selectedShow;
      this.selectedGroupBy = params['groupBy'] || this.selectedGroupBy;
      this.student = params['student'] || this.student;
      this.instructor = params['instructor'] || this.instructor;

      this.loadData();
    });
  }

  onYearChange(year: string) {
    this.year = year;
    this.WeeksForYearData = this._fieldsService.WeeksForYearData(Number(this.year));
  }

  onWeekYearChange(event: WeekYearChangeEvent): void {
    this.week = event.week;
    this.year = event.year;
    this.isDateRangeActive = event.isDateRangeActive;

    if (event.isDateRangeActive && event.dateRange) {
      this.dateTimeRange = [event.dateRange.start, event.dateRange.end];
    } else {
      this.dateTimeRange = [];
    }

    this.loadData();
  }

  override dataSource = new MatTableDataSource<any>([]);

  override ngAfterContentInit(): void {
    this._activatedRoute.queryParams.subscribe(data => {
      this.week = data['week'] || this._fieldsService.getCurrentWeek().toString();
      this.year = data['year'] || this._fieldsService.getCorrectYearForWeek(new Date()).toString();
      this.loadData();
    });
  }

  dateRangeChange(event: any) {
    if (event.value && Array.isArray(event.value)) {
      this.dateTimeRange = event.value;
      this.isDateRangeActive = true;
      this.loadData();
    }
  }

  loadData() {
    const params: { parameter: string; value: string }[] = [];

    if (this.isDateRangeActive && this.dateTimeRange?.length > 0) {
      params.push({ parameter: 'date_from', value: this.reportDateService.formatCalendarParam(this.dateTimeRange[0]) });
      params.push({ parameter: 'date_to', value: this.reportDateService.formatCalendarParam(this.dateTimeRange[1]) });
    } else if (this.week && this.year) {
      params.push({ parameter: 'week', value: this.week.toString() });
      params.push({ parameter: 'year', value: this.year });
    }

    // Add filter parameters
    if (this.selectedShow) params.push({ parameter: 'show', value: this.selectedShow });
    if (this.selectedGroupBy) params.push({ parameter: 'groupBy', value: this.selectedGroupBy });
    if (this.student) params.push({ parameter: 'student', value: this.student });
    if (this.instructor) params.push({ parameter: 'instructor', value: this.instructor });

    this.getData(params);
  }

  private getLastFourYears(): any[] {
    const currentYear = moment().year();
    return Array.from({ length: 4 }, (_, i) => ({
      key: (currentYear - i).toString(),
      value: (currentYear - i).toString()
    }));
  }

  override getData(params: { parameter: string; value: string }[]) {
    this.ShowProgressBar = true;

    if (!params.some(p => p.parameter === 'date_from')) {
      params.push({ parameter: 'weekYear', value: this.year.toString() });
      params.push({ parameter: 'weekNumber', value: this.week.toString() });
    }

    this._drupalRESTService.httpGET('/api_rest/v1/loadValueLessonTaughtReport', params).subscribe(
      data => {
        this.ShowProgressBar = false;
        this.reportData = data?.['report_data'] || [];
        this.dataSource.data = this.reportData;
        this.summary = data?.['summary'] || null;
      },
      error => this.handleError(error)
    );
  }

  override onPrint() {
    // Build HTML content directly from the data
    let content = `
      <h2 class="report-title">Value Lessons Taught Report</h2>
      <p class="report-period">
        ${this.isDateRangeActive && this.dateTimeRange?.length > 0
          ? `Date Range: ${this.reportDateService.formatDate(this.dateTimeRange[0])} to ${this.reportDateService.formatDate(this.dateTimeRange[1])}`
          : `Week: ${this.week}, Year: ${this.year}`
        }
      </p>
      <p class="report-filters">
        Show: ${this.selectedShow}<br>
        Group By: ${this.selectedGroupBy}<br>
        ${this.student ? `Student: ${this.student}<br>` : ''}
        ${this.instructor ? `Instructor: ${this.instructor}<br>` : ''}
      </p>
    `;

    // Report Data Section
    if (this.reportData.length > 0) {
      content += `
        <div class="section">
          <h3>${this.selectedShow} by ${this.selectedGroupBy}</h3>
          <table>
            <thead>
              <tr>
                <th>${this.selectedGroupBy}</th>
                ${this.selectedShow === 'Units Used' ? '<th>DE Units</th>' : ''}
                ${this.selectedShow === 'Units Used' ? '<th>Pre-Original Units</th>' : ''}
                <th>${this.selectedShow}</th>
                ${this.selectedShow === 'Units Used' ? '<th>Total Cost</th>' : ''}
              </tr>
            </thead>
            <tbody>
              ${this.reportData.map(item => `
                <tr>
                  <td>${this.selectedGroupBy === 'Day' ? this.reportDateService.formatDate(item.groupByValue) : (item.groupByValue || '')}</td>
                  ${this.selectedShow === 'Units Used' ? `<td>${item.de_units || '0'}</td>` : ''}
                  ${this.selectedShow === 'Units Used' ? `<td>${item.pre_original_units || '0'}</td>` : ''}
                  <td>${item.value || '0'}</td>
                  ${this.selectedShow === 'Units Used' ? `<td>${this.currencyService.format(item.total_cost !== undefined ? item.total_cost : this.calculateRowTotalCost(item))}</td>` : ''}
                </tr>
              `).join('')}
            </tbody>
            <tfoot>
              <tr>
                <td><strong>Total</strong></td>
                ${this.selectedShow === 'Units Used' ? `<td><strong>${this.getTotalDEUnits()}</strong></td>` : ''}
                ${this.selectedShow === 'Units Used' ? `<td><strong>${this.getTotalPreOriginalUnits()}</strong></td>` : ''}
                <td><strong>${this.getTotalValue()}</strong></td>
                ${this.selectedShow === 'Units Used' ? `<td><strong>${this.currencyService.format(this.getTotalCost())}</strong></td>` : ''}
              </tr>
            </tfoot>
          </table>
        </div>
      `;
    } else {
      content += '<p>No data found for this report</p>';
    }

    // Additional styles specific to this report
    const styles = `
      .report-title {
        font-size: 24px;
        text-align: center;
        margin-bottom: 10px;
      }
      .report-period, .report-filters {
        font-size: 14px;
        margin-bottom: 15px;
      }
      .section {
        margin-bottom: 30px;
        page-break-inside: avoid;
      }
      .section h3 {
        margin-bottom: 10px;
        color: #333;
        border-bottom: 1px solid #ddd;
        padding-bottom: 5px;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 20px;
      }
      th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
      }
      th {
        background-color: #f5f5f5;
        font-weight: bold;
      }
      tr:nth-child(even) {
        background-color: #f9f9f9;
      }
    `;

    // Create a formatted title
    let title = 'Value of Lessons Taught Report';
    if (this.isDateRangeActive && this.dateTimeRange?.length > 0) {
      const startDate = this.reportDateService.formatDate(this.dateTimeRange[0]);
      const endDate = this.reportDateService.formatDate(this.dateTimeRange[1]);
      title += ` - ${startDate} to ${endDate}`;
    } else {
      title += ` - Week ${this.week}, ${this.year}`;
    }

    this._printService.print(content, {
      title,
      styles,
      showSchoolName: true,
      promptPrint: true
    });
  }

  override resetForm() {
    this.dateTimeRange = [];
    this.isDateRangeActive = false;
    this.week = this._fieldsService.getCurrentWeek().toString();
    this.year = this._fieldsService.getCorrectYearForWeek(new Date()).toString();
    this.onYearChange(this.year);

    // Reset filter values
    this.selectedShow = 'Units Used';
    this.selectedGroupBy = 'Instructor';
    this.student = '';
    this.instructor = '';

    this.loadData();
  }

  getTotalValue(): number {
    return this.reportData
      .map(item => Number(item.value) || 0)
      .reduce((acc, value) => acc + value, 0);
  }

  getTotalCost(): number {
    if (this.selectedShow !== 'Units Used') {
      return 0;
    }

    // If we have summary data from the API, use that
    if (this.summary && this.summary.total_cost !== undefined) {
      return this.summary.total_cost;
    }

    // Otherwise calculate it from the report data
    return this.reportData
      .map(item => (Number(item.value) || 0) * (Number(item.unit_cost) || 0))
      .reduce((acc, cost) => acc + cost, 0);
  }

  getDisplayColumns(): string[] {
    if (this.selectedShow === 'Units Used') {
      return ['groupByValue', 'de_units', 'pre_original_units', 'value', 'unit_cost'];
    }
    return ['groupByValue', 'value'];
  }

  getTotalDEUnits(): number {
    if (this.selectedShow !== 'Units Used') {
      return 0;
    }

    if (this.summary && this.summary.total_de_units !== undefined) {
      return this.summary.total_de_units;
    }

    return this.reportData
      .map(item => Number(item.de_units) || 0)
      .reduce((acc, value) => acc + value, 0);
  }

  getTotalPreOriginalUnits(): number {
    if (this.selectedShow !== 'Units Used') {
      return 0;
    }

    if (this.summary && this.summary.total_pre_original_units !== undefined) {
      return this.summary.total_pre_original_units;
    }

    return this.reportData
      .map(item => Number(item.pre_original_units) || 0)
      .reduce((acc, value) => acc + value, 0);
  }

  getAverageUnitCost(): number {
    if (this.selectedShow !== 'Units Used') {
      return 0;
    }

    // If we have summary data from the API, use that
    if (this.summary && this.summary.total_unit_cost) {
      return this.summary.total_unit_cost;
    }

    // Otherwise calculate it from the report data
    const totalUnits = this.getTotalValue();
    if (totalUnits <= 0) {
      return 0;
    }

    const totalCost = this.reportData
      .map(item => (Number(item.value) || 0) * (Number(item.unit_cost) || 0))
      .reduce((acc, cost) => acc + cost, 0);

    return totalCost / totalUnits;
  }

  calculateRowTotalCost(element: any): number {
    if (this.selectedShow !== 'Units Used') {
      return 0;
    }

    return (Number(element.value) || 0) * (Number(element.unit_cost) || 0);
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }
    // DO NOT call updateRouterParams here - prevents duplicate requests
  }
}
